import {
  TrackContactCreationFilters,
  GetTrackContactCreationResponse,
} from '../../types/trackContactCreation/trackContactCreation.types';
import {
  GET_TRACK_CONTACT_CREATION_REQUEST,
  GET_TRACK_CONTACT_CREATION_SUCCESS,
  GET_TRACK_CONTACT_CREATION_FAILURE,
  CLEAR_TRACK_CONTACT_CREATION_STATE,
  GetTrackContactCreationRequestAction,
  GetTrackContactCreationSuccessAction,
  GetTrackContactCreationFailureAction,
  ClearTrackContactCreationStateAction,
} from './trackContactCreation.types';

// Get Track Contact Creation Actions
export const getTrackContactCreationRequest = (
  filters: TrackContactCreationFilters = {}
): GetTrackContactCreationRequestAction => ({
  type: GET_TRACK_CONTACT_CREATION_REQUEST,
  payload: filters,
});

export const getTrackContactCreationSuccess = (
  response: GetTrackContactCreationResponse
): GetTrackContactCreationSuccessAction => ({
  type: GET_TRACK_CONTACT_CREATION_SUCCESS,
  payload: response,
});

export const getTrackContactCreationFailure = (
  error: string
): GetTrackContactCreationFailureAction => ({
  type: GET_TRACK_CONTACT_CREATION_FAILURE,
  payload: error,
});

export const clearTrackContactCreationState =
  (): ClearTrackContactCreationStateAction => ({
    type: CLEAR_TRACK_CONTACT_CREATION_STATE,
  });
